export enum AccountSection {
  CUSTOMERS = "customers",
  DEBTORS = "debtors",
  CREDITORS = "creditors",
}

export function parseAccountSection(raw: string | null | undefined): AccountSection {
  const value = String(raw || "").trim().toLowerCase();
  if (value === AccountSection.DEBTORS) return AccountSection.DEBTORS;
  if (value === AccountSection.CREDITORS) return AccountSection.CREDITORS;
  return AccountSection.CUSTOMERS;
}
